<template>
  <v-navigation-drawer
    v-model="drawer"
    temporary
    width="340"
  >
    <v-list density="compact" nav slim>
      <v-list-item class="mb-2" density="compact">
        <v-text-field
          id='navFilter'
          v-model="searchFilter"
          class="mt-1"
          label="Search Menus"
          :clearable="true"
          autocomplete="off"
          density="compact"
          variant="underlined"
          prepend-inner-icon="search"
          hide-details
          autofocus
          @keydown.up.prevent="handleArrowKey"
          @keydown.down.prevent="handleArrowKey"
          @keydown.enter="handleEnterKey"
        />
      </v-list-item>
      <v-divider ref="menuDivider" />
      <template
        v-for="(item, index) in filteredMenuItems"
      >
        <MenuItem
          v-if="item.type === 'I' || item.type === 'A'"
          :id="getMenuItemId(index)"
          :key="index"
          :icon="item.icon"
          :label="menuLabel(item.title)"
          :route="item.route"
          :isAction="item.type === 'A'"
        />

        <MenuGroup
          v-else-if="item.type === 'M'"
          :id="getMenuItemId(index)"
          :key="`${index}-menu-group`"
          :item="item"
        />

        <v-divider v-else-if="item.type === 'D'" :key="`${index}-divider`" />
      </template>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import { mapGetters } from 'vuex';
import _isEqual from 'lodash/isEqual';
import MenuItem from '@/components/core/menu/MenuItem.vue';
import MenuGroup from '@/components/core/menu/MenuGroup.vue';

import { reduce } from '@/lib/utils';

/**
 * Menu for displaying and searching of Loft menu items.
 */
export default {
  components: {
    MenuItem,
    MenuGroup,
  },

  data() {
    return {
      searchFilter: '',
    };
  },

  mounted() {
    window.addEventListener('keydown', (e) => {
      if ((e.ctrlKey || e.metaKey) && e.key === 'k') {
        e.preventDefault();
        this.$store.dispatch('menu/toggleState');
      }
    });
  },

  watch: {
    drawer: {
      handler(newVal) {
        if (newVal) {
          this.searchFilter = '';
          document.getElementById('navFilter').focus();
        }
      },
    },
  },

  computed: {
    filteredMenuItems() {
      if (this.searchFilter && this.searchFilter.length >= 2) {
        const regex = new RegExp(this.searchFilter.replace(/\//g, ''), 'gi');
        const hasItems = (acc, item) => {
          if (item.items) {
            return reduce(item.items, hasItems, acc);
          }
          if (item.route &&
              item.title &&
              this.menuLabel(item.title).replace(/\//g, '').match(regex) &&
              acc.findIndex(i => _isEqual(i, item)) === -1) {
            acc.push(item);
          }
          return acc;
        };

        return reduce(this.menuItems, hasItems, []);
      }
      return this.menuItems;
    },

    drawer: {
      get() {
        return this.drawerState;
      },
      set(val) {
        if (this.drawerState && !val) {
          this.$store.dispatch('menu/toggleState');
        }
      },
    },

    ...mapGetters({
      drawerState: 'menu/drawer',
      menuItems: 'menu/menuItems',
      menuLabel: 'menu/menuLabel',
      translateMenuAction: 'menu/translateMenuAction',
    }),
  },

  methods: {
    getMenuItemId(index) {
      if (index === 0) return 'menu-start';
      if (index === this.filteredMenuItems.length - 1) return 'menu-end';
      return null;
    },

    handleArrowKey(e) {
      const pos = e.key === 'ArrowDown' || this.filteredMenuItems.length === 1 ? 'start' : 'end';
      let el = document.getElementById(`menu-${pos}`);
      if ([...el.classList].includes('v-list-group')) el = el.querySelector('.v-list-item');
      el.focus();
    },

    handleEnterKey() {
      if (this.filteredMenuItems.length && this.searchFilter?.length > 1) {
        const item = this.filteredMenuItems[0];
        if (item.type === 'I') this.$router.push(item.route);
        else if (item.type === 'A') this.translateMenuAction(item.route.name);
      }
    },
  },
};
</script>
